import React from 'react';
import { Container } from 'react-bootstrap';
import './Loader.css';
import Layout from './Layout';

export type LoaderScreenProps = {
    message: string;
    noLayout?: boolean;
}

const LoaderScreen = (props: LoaderScreenProps) => {
    const content = (
        <Container fluid className="text-center">
            <div className="blinking-tree-container d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <img src="blinking-tree.gif" alt="Loading..." className="blinking-tree mb-4" />
                <div>
                    <p className="h5 mb-2">Loading...</p>
                    <p className='content text-muted'>{props.message}</p>
                </div>
            </div>
        </Container>
    );

    return props.noLayout ? content : (
        <Layout>
            {content}
        </Layout>
    );
};

export default LoaderScreen;